export default "__VITE_ASSET__1f7366c7__"